import * as React from "react";
import {Icon} from "./Icon";

export class MetaDataTranslateIcon extends Icon {

  render() {
    return <Icon {...this.props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
        <path d="M10,42V6H30v8h8V34h2V12L32,4H8V44H24V42ZM32,6.83,37.17,12H32Z" />
        <polygon points="45 37 42 34 42 36 30 36 30 38 42 38 42 40 45 37" />
        <polygon points="25 41 28 44 28 42 40 42 40 40 28 40 28 38 25 41" />
        <path d="M23.49,22.49a1.94,1.94,0,0,1,1.06.29,1.12,1.12,0,0,1,.39,1c0,.19,0,.48-1,3.76-1.25,4-1.54,5.59-1.54,6.07.1-.1.67-.48,1.93-1.64l.39-.29L26,32.9l-.39.39a28.55,28.55,0,0,1-3,2.51,3.66,3.66,0,0,1-1.73.58,1.6,1.6,0,0,1-1.16-.48,1.83,1.83,0,0,1-.48-1.25c0-1.25.77-4.24,2.22-9.16-.19,0-.58.29-1.64,1.35l-.39.29L18,26.05l.39-.39a10.11,10.11,0,0,1,2.8-2.41A5,5,0,0,1,23.49,22.49Zm0-5.49a2,2,0,1,1-2,2A2,2,0,0,1,23.49,17Z" />
      </svg>
    </Icon>;
  }
}
